
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../../../components/feature/LanguageSwitcher';

const heroImages = [
  'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/310057a4198c082ab1e3a4d0ce575f55.jpeg',
  'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/8d2c911684c88a1546a89f5a040590a1.jpeg',
  'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/72d3bdaf276430134968b8415f38f060.jpeg',
  'https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/99b55c20ff8d6f1fcfaa93236076a3df.jpeg',
];

export default function Hero() {
  const { t } = useTranslation();
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="relative h-screen w-full overflow-hidden">
      {/* Title - Above images on mobile */}
      <div className="md:hidden absolute top-20 left-0 right-0 flex flex-col items-center text-center px-4 z-30">
        <h1 className="text-2xl font-bold text-white mb-2 drop-shadow-2xl max-w-5xl">
          {t('hero_title')}
        </h1>
      </div>

      {heroImages.map((image, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/30 z-10"></div>
          <div className="w-full h-full">
            <img
              src={image}
              alt={`Villa view ${index + 1}`}
              className="w-full h-full object-contain md:object-cover md:object-[65%_center]"
              onError={(e) => {
                console.error(`Failed to load image: ${image}`);
                const target = e.target as HTMLImageElement;
                target.src = '/fallback-image.jpg';
              }}
            />
          </div>
        </div>
      ))}

      <div className="absolute top-6 right-6 z-30">
        <LanguageSwitcher />
      </div>

      {/* Title and subtitle - Desktop only */}
      <div className="hidden md:flex absolute inset-0 flex-col items-center justify-center text-center px-4 z-20">
        <h1 className="text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-6 drop-shadow-2xl max-w-5xl">
          {t('hero_title')}
        </h1>
        <p className="text-2xl lg:text-3xl text-white/95 mb-12 drop-shadow-xl max-w-3xl font-light">
          {t('hero_property_info')}
        </p>
      </div>

      {/* Description - Below images on mobile */}
      <div className="md:hidden absolute bottom-32 left-0 right-0 flex flex-col items-center text-center px-4 z-30">
        <p className="text-xs text-white/95 mb-4 drop-shadow-xl max-w-3xl font-light">
          {t('hero_property_info')}
        </p>
      </div>

      <div className="absolute bottom-16 left-0 right-0 flex justify-center z-20">
        <div className="mb-4">
          <p className="text-lg md:text-3xl lg:text-4xl font-bold text-white drop-shadow-2xl">
            €1,990,000
          </p>
        </div>
      </div>

      <div className="absolute bottom-8 left-0 right-0 flex justify-center gap-3 z-20">
        {heroImages.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`h-1 rounded-full transition-all cursor-pointer ${
              index === currentSlide ? 'bg-white w-12' : 'bg-white/50 w-8'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
}
